export class DateFormatter {
    cache: Record<string, string> = { };

    constructor(
        private readonly locale: string,
    ) {

    }

    formatDate(input: Date|string): string {
        const date = input instanceof Date ? input : new Date(input);
        const cacheKey =  `${date.toISOString()}-date`;

        if (!this.cache[cacheKey]) {
            this.cache[cacheKey] = date.toLocaleDateString(this.locale, {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            });
        }

        return this.cache[cacheKey];
    }

    formatDateTime(input: Date|string): string {
        const date = input instanceof Date ? input : new Date(input);
        const cacheKey =  `${date.toISOString()}-datetime`;

        if (!this.cache[cacheKey]) {
            this.cache[cacheKey] = date.toLocaleString(this.locale, {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
            });
        }

        return this.cache[cacheKey];
    }
}
